import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import closeIcon from "../../assets/icons/x-circle.svg";
import plusCircle from "../../assets/icons/plusCircle.svg";



const ActionAssignmentModel = ({ value, onChange }) => {
    const ENUM_OPTION_WORKER = 'Worker'
    const ENUM_OPTION_TEAMS = 'Teams'
    const ENUM_OPTION_SYSTEM = 'System'

    const [openAssignmentPopup, setOpenAssignmentPopup] = useState(false)
    const [option, setOption] = useState(ENUM_OPTION_WORKER);


    return (
        <>
            <div
                className="date-selector-calender-icon">
                <img className="pt-2"
                    src={value ? value : plusCircle}
                    alt="assign"
                    onClick={() => { setOpenAssignmentPopup(!openAssignmentPopup) }}
                />

            </div>

            {openAssignmentPopup &&
                <div className='assign-to-model'>
                    <div className='model-header'>
                        <Row style={{width: "100%"}} className="ms-2">
                            <Col className='d-flex'>
                                <div className='d-flex assign-to-selection'>
                                    <div className={option === ENUM_OPTION_WORKER ? 'selected' : ''}
                                        onClick={() => {
                                            setOption(ENUM_OPTION_WORKER)
                                        }}
                                    >
                                        {ENUM_OPTION_WORKER}
                                    </div>
                                    <div className={option === ENUM_OPTION_TEAMS ? 'selected' : ''}
                                        onClick={() => {
                                            setOption(ENUM_OPTION_TEAMS)
                                        }}
                                    >
                                        {ENUM_OPTION_TEAMS}
                                    </div>
                                    <div className={option === ENUM_OPTION_SYSTEM ? 'selected' : ''}
                                        onClick={() => {
                                            setOption(ENUM_OPTION_SYSTEM)
                                        }}
                                    >
                                        {ENUM_OPTION_SYSTEM}
                                    </div>
                                </div>
                                <input type='text' placeholder='Search' className='ps-3 ms-3 search-assignee'/>
                            </Col>
                            <Col xl={1} className='me-2'>
                                <img className="cursor-pointer close-btn-big" src={closeIcon} alt=""
                                    onClick={() => {
                                        setOpenAssignmentPopup(false);
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>

                    {option === ENUM_OPTION_WORKER && 
                        <div className='assignment-content'>
                            Worker Section
                        </div>
                    }  

                    {option === ENUM_OPTION_TEAMS && 
                        <div className='assignment-content'>
                            Team Section
                        </div>
                    } 

                    {option === ENUM_OPTION_SYSTEM && 
                        <div className='assignment-content'>
                            system section
                        </div>
                    }  


                </div>
            }
        </>
    )
}

export default ActionAssignmentModel